import { render, staticRenderFns } from "./IconCheck.vue?vue&type=template&id=12aa9a75&scoped=true&lang=pug"
import script from "./IconCheck.vue?vue&type=script&lang=js"
export * from "./IconCheck.vue?vue&type=script&lang=js"
import style0 from "./IconCheck.vue?vue&type=style&index=0&id=12aa9a75&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12aa9a75",
  null
  
)

export default component.exports